import { NgModule } from '@angular/core';
import { CoreModule } from 'src/app/core/core.module';
import { CommonAtcExpandableTableComponent } from './atc/common.atc-exp-table.component';
import { CommonAtcTableComponent } from './atc/common.atc-table.component';
import { CommonAtcUploadModelComponent } from './atc/common.atc-upload-modal.component';
import { CommonAtcComponent } from './atc/common.atc.component';
import { CommonMedicineComponent } from './atc/medicine/common.medicine.component';
import { CieComponent } from './cie/cie.component';
import * as Doctor from './doctor/doctor.components';
import * as Patient from './patient/patient.components';
import * as Person from './person/person.components';
import * as Turn from './turn/turn.components';

const atcComponents = [
  CommonAtcComponent,
  CommonAtcTableComponent,
  CommonAtcExpandableTableComponent,
  CommonAtcUploadModelComponent,
  CommonMedicineComponent,
];

const turnComponents = [
  Turn.CommentDialogComponent,
  Turn.DialogComponent,
  Turn.FormComponent,
  Turn.MainComponent,
  Turn.PatientSearchComponent,
];

const personComponents = [
  Person.DialogComponent,
  Person.FormComponent,
  Person.MainComponent,
];

const doctorComponents = [
  Doctor.DialogComponent,
  Doctor.FormComponent,
  Doctor.MainComponent,
  Doctor.SpecialtiesDialogComponent,
];

const patientComponents = [
  Patient.DialogComponent,
  Patient.FormComponent,
  Patient.MainComponent,
];

@NgModule({
  declarations: [
    ...atcComponents,
    CieComponent,
    ...turnComponents,
    ...personComponents,
    ...doctorComponents,
    ...patientComponents,
  ],
  imports: [CoreModule],
  entryComponents: [],
  exports: [
    ...atcComponents,
    CieComponent,
    ...turnComponents,
    ...personComponents,
    ...doctorComponents,
    ...patientComponents,
  ],
})
export class CommonModule {}
